import { Building } from '@/reducers/types'

import { PlaceFlags } from './features/places-features.constants'

export const getServerTags = (building: Building) => (building.tags ?? []).map(String)

interface BuildPlaceUpdatePayloadParams {
  flags?: PlaceFlags
  scalars?: Record<string, unknown>
  server: Building
}

// Note: the backend treats a missing `code` as a duplicate of every other building and a missing
// `tags` as "remove all tags", so both are sent on every save with their stored values
export const buildPlaceUpdatePayload = ({
  flags = {},
  scalars = {},
  server,
}: BuildPlaceUpdatePayloadParams): Record<string, unknown> => ({
  code: server.code,
  tags: getServerTags(server),
  ...scalars,
  ...flags,
})
